/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import User from "../../../assets/img/icons/user3.png";
import { Link, useNavigate, useParams } from "react-router-dom";
import ProfileTab from "./ProfileTab";
import Breadcrumbs from "../../../components/Breadcrumbs";
import config from "../../../config";
import { formatDate } from "../../../validation";
import { capitalizeFirstLetter } from "../../../utils/basicFunctions";
import EditCandidatesModal from "../../../components/Administration/Jobs/CandidatesModal/EditCandidatesModal";
import ImageEditor from "../../../components/ImageEditor";
import ResignationModal from "../../../components/modelpopup/ResignationModal";
import {
  onLoginSuccess,
  onLogoutSuccess,
} from "../Authentication/TrackingHandler";
import api from "../../../api/axios";
import Loader from "../../../components/Loader";
import Swal from "sweetalert2";
import useEmployeeLocation from "../../../hooks/useEmployeeLocation";
import { companyID, getEmployeeLocalDetails } from "../../../auth";
import CompanyCoordinatesError from "../Authentication/CompanyCoordinatesError";
import { getEmployeeTimeZoneDate } from "../../../utils/getEmployeeTimeZoneDate";
import { getFile } from "../../../utils/getFile";
import { useLocation } from "react-router-dom";
import EmployeeQuickLinks from "../../../components/EmployeeQuickLinks";
import "../../../assets/css/main.css";
import { decrypt } from "../../../utils/crypto";
import EmployeePIP from "../HR/PIP/EmployeePIP";
import WorkDateSelector from "./WorkDateSelector";
import EventCountdown from "./EventCountdown"; 
import PasswordReset from "./PasswordReset";

const Profile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { activeTab = "emp_profile" } = location.state || {};
  let { employee_id } = useParams();
  employee_id = decrypt(employee_id);
  const [basicDetails, setBasicsDetails] = useState({});
  const [addressDetails, setAddressDetails] = useState([]);
  const [qualificationDetails, setQualificationDetails] = useState([]);
  const [accountDetails, seAccountDetails] = useState({});
  const [employmentDetails, setEmploymentDetails] = useState([]);
  const [editTrue, setEditedTrue] = useState(false);
  const [res, setRes] = useState({});
  const [employeeID, setEmployeeID] = useState("");
  const [fieldOne, setFieldOne] = useState(true);
  const [fieldFour, setFieldFour] = useState(false);
  const [isMainModalOpen, setIsMainModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [attendance, setAttendance] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [showLinks, setShowLinks] = useState(false);
  const [alreadyApplied, setAlreadyApplied] = useState(false);
  const [wfhWorkDates, setWfhWorkDates] = useState([]);
  const loginEmployeeId = localStorage.getItem("employeeID");
  const work_location = localStorage.getItem("work_location");
  const employee_role = localStorage.getItem("employee_role");
  console.log("employee_role", employee_role);
  const company_id = companyID();
  const [loading, setLoading] = useState({
    show: false,
    message: "",
  });
  const [profileImage, setProfileImage] = useState({});
  const {
    getEmployeeCurrentPosition,
    showModal,
    locationErrorMessage,
    setShowModal,
  } = useEmployeeLocation();

  const employeeLocalDetails = getEmployeeLocalDetails();

  useEffect(() => {
    if (isEditModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.removeProperty("overflow");
    }
    return () => {
      document.body.style.removeProperty("overflow");
    };
  }, [isEditModalOpen]);

  const employeeAttendance = () => {
    api
      .get(`api/attendance/${employee_id}`)
      .then((res) => {
        const todayDate = getEmployeeTimeZoneDate();
        const attendance = res?.data?.filter(
          (record) => record.Date == todayDate
        );
        setAttendance(attendance);
      })
      .catch((err) => console.error("Error fetching attendance data:", err));
  };

  const employeeWFHDates = async () => {
    try {
      const approved = "rejected";
      const response = await api.get(
        `company/work_date?employee_id=${employee_id}&login_status=${approved}`
      );
      setWfhWorkDates(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    employeeAttendance();
    employeeWFHDates();
  }, []);

  const markAttendance = async () => {
    setLoading({ show: true, message: `Checking current location...` });
    let inLocation = true;
    if (work_location == 1) {
      // Get the current date in YYYY-MM-DD format for comparison
      const currentDate = getEmployeeTimeZoneDate();

      // Check if current date exists in wfhWorkDates
      const isWFHDate = wfhWorkDates ? wfhWorkDates.some(
        (wfh) => wfh.work_date.split("T")[0] === currentDate
      ) : null;

      // If current date is not in wfhWorkDates, check location
      if (!isWFHDate) {
        inLocation = await getEmployeeCurrentPosition(company_id);
      }
      else{
        inLocation = true;
      }
    }
    if (inLocation || work_location != 1) {
      try {
        setLoading({ show: true, message: `Marking Attendance...` });
        const punchDate = getEmployeeTimeZoneDate();
        const { data } = await api.post(
          `auth/mark-attendance/${loginEmployeeId}`,
          {
            punchDate: punchDate,
          }
        );
        Swal.fire({
          title: "Attendance",
          text: data?.message,
          icon: "success",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-primary",
          },
        });

        onLoginSuccess(
          employeeLocalDetails?.id,
          employeeLocalDetails?.work_start_time,
          employeeLocalDetails?.work_end_time
        );
        employeeAttendance();
      } catch (error) {
        Swal.fire({
          title: "Attendance",
          text: "Something went wrong. Please try again later!",
          icon: "warning",
          confirmButtonText: "OK",
          timer: 2000,
          timerProgressBar: true,
          customClass: {
            confirmButton: "btn btn-warning",
          },
        });
        console.error(error);
      } finally {
        setLoading({ show: false, message: "" });
      }
    } else {
      setLoading({ show: false, message: "" });
    }
  };

  useEffect(() => {
    api
      .get(`employees/${employee_id}`)
      .then((res) => {
        setRes(res);
        setBasicsDetails(res?.data?.result?.basicDetails);
        setAddressDetails(res?.data?.result?.addresses);
        setQualificationDetails(res?.data?.result?.qualifications);
        setEmploymentDetails(res?.data?.result?.employmentDetails[0]);
        seAccountDetails(res?.data?.result?.accountDetails[0]);
      })
      .catch((err) => console.error(err));
  }, [editTrue, employeeID]);

  useEffect(() => {
    api
      .get(`employees/${employee_id}`)
      .then((res) => {
        setRes(res);
      })
      .catch((err) => console.error(err));
  }, [employeeID]);

  const handlePunchOut = async (e) => {
    e.preventDefault();
    setLoading({ show: true, message: `Checking current location...` });
    const companyName = localStorage.getItem("companyName");

    let inLocation = true;
    if (work_location == 1) {
      // inLocation = await getEmployeeCurrentPosition(company_id);
      const currentDate = getEmployeeTimeZoneDate();

      // Check if current date exists in wfhWorkDates
      const isWFHDate = wfhWorkDates ? wfhWorkDates.some(
        (wfh) => wfh.work_date.split("T")[0] === currentDate
      ) : null;

      // If current date is not in wfhWorkDates, check location
      if (!isWFHDate) {
        inLocation = await getEmployeeCurrentPosition(company_id);
      }
      else{
        inLocation = true;
      }
    }

    if (inLocation || work_location != 1) {
      setLoading({ show: true, message: "Checking Out Attendance..." });
      const punchDate = getEmployeeTimeZoneDate();
      api
        .post(`auth/logout`, {
          employeeId: employee_id,
          checkOut: true,
          punchDate: punchDate,
        })
        .then((res) => {
          if (res.data.success === true) {
            employeeAttendance();
            onLogoutSuccess();
            Swal.fire({
              title: "Attendance",
              text: "Check Out successfully.",
              icon: "success",
              confirmButtonText: "OK",
              timer: 2000,
              timerProgressBar: true,
              customClass: {
                confirmButton: "btn btn-primary",
              },
            });
          }
        })
        .catch((err) => {
          Swal.fire({
            title: "Attendance",
            text: "Something went wrong. Please try again later!",
            icon: "warning",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
          console.error("Error during logout:", err);
        })
        .finally(() => {
          setLoading({ show: false, message: "" });
        });
    } else {
      setLoading({ show: false, message: "" });
    }
  };

  const handlePunchIn = async (e) => {
    e.preventDefault();
    setLoading({ show: true, message: `Checking current location...` });
    let inLocation = true;

    if (work_location == 1) {
      // inLocation = await getEmployeeCurrentPosition(company_id);
      const currentDate = getEmployeeTimeZoneDate();

      // Check if current date exists in wfhWorkDates
      const isWFHDate = wfhWorkDates ?wfhWorkDates.some(
        (wfh) => wfh.work_date.split("T")[0] === currentDate
      ) : null;

      // If current date is not in wfhWorkDates, check location
      if (!isWFHDate) {
        inLocation = await getEmployeeCurrentPosition(company_id);
      }
      else{
        inLocation = true;
      }
    }
    if (inLocation || work_location != 1) {
      console.log("calling.... pinch in work_location", work_location);
      setLoading({ show: true, message: "Checking In Attendance..." });
      const punchDate = getEmployeeTimeZoneDate();
      api
        .post(`api/attendance/punch-in`, {
          employeeId: employee_id,
          checkIn: true,
          punchDate: punchDate,
        })
        .then(() => {
          Swal.fire({
            title: "Attendance",
            text: "Check In successfully.",
            icon: "success",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });
          employeeAttendance();
        })
        .catch((err) => {
          Swal.fire({
            title: "Attendance",
            text: "Something went wrong. Please try again later!",
            icon: "warning",
            confirmButtonText: "OK",
            timer: 2000,
            timerProgressBar: true,
            customClass: {
              confirmButton: "btn btn-warning",
            },
          });
          console.error(err);
        })
        .finally(() => {
          setLoading({ show: false, message: "" });
        });
    } else {
      setLoading({ show: false, message: "" });
    }
  };

  useEffect(() => {
    const fetchImage = async () => {
      let image = null;
      if (basicDetails.photo) {
        const imageUrl = await getFile(
          `${config.IMAGE_URL}${basicDetails.photo}`
        );
        if (imageUrl) {
          image = imageUrl;
        }
      }
      setProfileImage(image);
    };

    fetchImage();
  }, [basicDetails]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Profile"
            title="Dashboard"
            subtitle="Profile"
            modal="#add_indicator"
            name="Add New"
          />
          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        <Link
                          to="#"
                          onClick={(e) => {
                            e.preventDefault();
                            setIsMainModalOpen(true);
                          }}
                        >
                          <img src={profileImage || User} alt="User Image" />
                        </Link>
                      </div>
                    </div>
                    <div className="profile-basic">
                      <div className="row">
                        <div className="col-md-5">
                          <div className="profile-info-left">
                            <h3 className="user-name m-t-0 mb-0 capitalize-each-word">
                              {localStorage.getItem("demo_user_name") ||
                                [
                                  basicDetails?.first_name,
                                  basicDetails?.middle_name,
                                  basicDetails?.last_name,
                                ]
                                  .filter(Boolean)
                                  .join(" ")}
                            </h3>
                            <h6 className="text-muted">
                              {employmentDetails?.department_name}
                            </h6>
                            <small className="text-muted">
                              {employmentDetails?.designation_name}
                            </small>
                            <div className="staff-id">
                              Employee ID:{" "}
                              {employmentDetails?.employment_id || "N/A"}
                            </div>
                            <div className="small doj text-muted">
                              Date of Join :
                              {employmentDetails?.joining_date &&
                                formatDate(employmentDetails?.joining_date)}
                            </div>
                            {/* <div style={{display:'flex', gap:'10px'}}> */}
                            {/* <div className="staff-msg">
                              <Link
                                
                                className="btn btn-custom" 
                                to="#"
                                onClick={(e)=>{
                                  e.preventDefault();
                                  setIsEditModalOpen(true);
                                }}
                              >
                                Edit Profile
                              </Link>
                            </div> */}
                            {
                              <div className="staff-msg title">
                                {employee_id == loginEmployeeId &&
                                  (attendance.length != 0 ? (
                                    <Link
                                      className="btn btn-custom"
                                      style={{
                                        background: `${
                                          !attendance[0]?.punch_status
                                            ? "red"
                                            : "green"
                                        }`,
                                        color: "white",
                                      }}
                                      to="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        !attendance[0]?.punch_status
                                          ? handlePunchOut(e)
                                          : handlePunchIn(e);
                                      }}
                                    >
                                      {!attendance[0]?.punch_status
                                        ? "Check Out"
                                        : "Check In"}
                                    </Link>
                                  ) : (
                                    <button
                                      className="btn btn-success"
                                      onClick={markAttendance}
                                    >
                                      <i
                                        className="fa-solid fa-clipboard-user me-1"
                                        title="Mark your today's attendance"
                                      />
                                      Check In
                                    </button>
                                  ))}
                                {employee_role == 1 || employee_role == 2 ? (
                                  <WorkDateSelector
                                    employee_id={employee_id}
                                    wfhWorkDates={wfhWorkDates}
                                    employeeWFHDates={employeeWFHDates}
                                  />
                                ) : (
                                  <></>
                                )}
                              </div>
                            }
                            {/* </div> */}
                          </div>
                        </div>
                        <div className="col-md-7">
                          <ul className="personal-info">
                            <li>
                              <div className="title">Phone:</div>
                              <div className="text">
                                <Link
                                  to={`tel:${
                                    localStorage.getItem("demo_user_phone") ||
                                    basicDetails?.number
                                  }`}
                                >
                                  {localStorage.getItem("demo_user_phone") ||
                                    basicDetails?.number}
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Official Email:</div>
                              <div className="text">
                                <Link
                                  to={`mailto:${
                                    localStorage.getItem("demo_user_email") ||
                                    basicDetails?.official_email
                                  }}`}
                                >
                                  {localStorage.getItem("demo_user_email") ||
                                    basicDetails?.official_email}
                                </Link>
                              </div>
                            </li>
                            <li>
                              <div className="title">Birthday:</div>
                              <div className="text">
                                {(basicDetails?.date_of_birth &&
                                  formatDate(basicDetails?.date_of_birth)) ??
                                  "-"}
                                {basicDetails?.date_of_birth && (
                                  <EventCountdown
                                    date={basicDetails?.date_of_birth}
                                    type={"birthdate"}
                                  />
                                )}
                              </div>
                            </li>
                            {/* <li>
                            <div className="title">Address:</div>
                            <div className="text">
                              {capitalizeFirstLetter(
                                addressDetails[0]?.address
                              )}
                            </div>
                          </li> */}
                            <li>
                              <div className="title">Gender:</div>
                              <div className="text">
                                {basicDetails?.gender ?? "-"}
                              </div>
                            </li>
                            <li>
                              <div className="title">Employment Status: </div>
                              <div
                                className="text"
                                style={{ textTransform: "capitalize" }}
                              >
                                {employmentDetails?.employment_status ?? "-"}
                              </div>
                            </li>
                            {/* <li>
                              <div className="title">Reports to:</div>
                              <div className="text">
                                <div className="avatar-box">
                                  <div className="avatar avatar-xs">
                                    <img src={Avatar_16} alt="User Image" />
                                  </div>
                                </div>
                                <Link to="profile">
                                  {userData.supervisor.name}
                                </Link>
                              </div>
                            </li> */}
                            {/* {!alreadyApplied &&
                              employee_id == loginEmployeeId && (
                                <li>
                                  <div className="title">Separation:</div>
                                  <div className="text">
                                    <button
                                      className="btn btn-danger py-0"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setModalShow(true);
                                      }}
                                    >
                                      Apply
                                    </button>
                                  </div>
                                </li>
                              )} */}
                            <li>
                              <div className="title">Quick links:</div>
                              <div className="text">
                                <button
                                  className={`btn btn-${
                                    !showLinks ? "primary" : "outline-primary"
                                  } py-0`}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setShowLinks(!showLinks);
                                  }}
                                >
                                  {!showLinks ? "Show" : "Hide"}
                                  {/* <i
                                    className={`ms-2 fa-${
                                      showLinks ? "regular" : "solid"
                                    } fa-square-caret-down `}
                                  ></i> */}
                                </button>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="pro-edit">
                      <Link
                        data-bs-target="#edit_employee"
                        data-bs-toggle="modal"
                        className="edit-icon"
                        // to={`../edit-employee/${id}`}
                        onClick={(e) => {
                          setEmployeeID(employee_id);
                        }}
                        to="#"
                      >
                        <i className="fa-solid fa-pencil"></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="m-2 mt-0">
              {/* <div className="title fw-bold">Quick links:</div> */}
              {showLinks && (
                <EmployeeQuickLinks
                  employee_id={employee_id}
                  basicDetails={basicDetails}
                />
              )}
            </div>
          </div>

          <div className="card tab-box">
            <div className="row user-tabs">
              <div className="col-lg-12 col-md-12 col-sm-12 line-tabs">
                <ul className="nav nav-tabs nav-tabs-bottom">
                  <li className="nav-item">
                    <Link
                      to="#emp_profile"
                      data-bs-toggle="tab"
                      className={`nav-link ${
                        activeTab === "emp_profile" ? "active" : ""
                      }`}
                    >
                      Profile
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#emp_resignation"
                      data-bs-toggle="tab"
                      className={`nav-link ${
                        activeTab === "emp_resignation" ? "active" : ""
                      }`}
                    >
                      Separation
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      to="#org_hierarchy"
                      data-bs-toggle="tab"
                      className={`nav-link ${
                        activeTab === "org_hierarchy" ? "active" : ""
                      }`}
                    >
                      ORG Hierarchy
                    </Link>
                  </li>
                  {employeeLocalDetails?.employment_status == "PIP" &&
                    employeeLocalDetails?.id == employee_id && (
                      <li className="nav-item">
                        <Link
                          to="#pip"
                          data-bs-toggle="tab"
                          className={`nav-link ${
                            activeTab === "pip" ? "active" : ""
                          }`}
                        >
                          PIP
                        </Link>
                      </li>
                    )}
                  {employeeLocalDetails?.id == employee_id && (
                    <li className="nav-item">
                      <Link
                        to="#password_reset"
                        data-bs-toggle="tab"
                        className={`nav-link ${
                          activeTab === "password_reset" ? "active" : ""
                        }`}
                      >
                        Password Reset
                      </Link>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
          {/* Profile Info Tab */}
          <ProfileTab
            basicDetails={basicDetails}
            addressDetails={addressDetails}
            employmentDetails={employmentDetails}
            qualificationDetails={qualificationDetails}
            accountDetails={accountDetails}
            setBasicsDetails={setBasicsDetails}
            seAccountDetails={seAccountDetails}
            setAddressDetails={setAddressDetails}
            setQualificationDetails={setQualificationDetails}
            setEditedTrue={setEditedTrue}
            editTrue={editTrue}
            // setFieldThree={setFieldThree}
            setFieldFour={setFieldFour}
            id={employee_id}
            setFieldOne={setFieldOne}
            setAlreadyApplied={setAlreadyApplied}
            separationModal={modalShow}
            activeTab={activeTab}
            setModalShow={setModalShow}
            alreadyApplied={alreadyApplied}
            employee_id={employee_id}
            loginEmployeeId={loginEmployeeId}
          />
          <PasswordReset activeTab={activeTab} />
          <EditCandidatesModal
            employID={employee_id}
            setEditedTrue={setEditedTrue}
            fieldFour={fieldFour}
            setFieldFour={setFieldFour}
            fieldOne={fieldOne}
            setFieldOne={setFieldOne}
            res={res}
            isEditModalOpen={isEditModalOpen}
            setIsEditModalOpen={setIsEditModalOpen}
          />
          <ResignationModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            employeeId={employee_id}
          />
          <EmployeePIP activeTab={activeTab} />
        </div>
        {isEditModalOpen && <div className="modal-backdrop fade show"></div>}
      </div>
      <ImageEditor
        profileImage={profileImage}
        dummyPhoto={User}
        isMainModalOpen={isMainModalOpen}
        setIsMainModalOpen={setIsMainModalOpen}
        employeeId={employee_id}
        setEditedTrue={setEditedTrue}
        editTrue={editTrue}
      />
      <Loader show={loading.show} loadingMessage={loading.message} />
      <CompanyCoordinatesError
        errorMessage={locationErrorMessage}
        show={showModal}
        handleClose={() => setShowModal(false)}
      />
    </>
  );
};

export default Profile;
